module.exports = __webpack_public_path__ + "img/n_logo2@3x.b915b0de.png";